import { practice } from "../../data/practice";
import { organizationId } from "./practiceEntity";

const WEBSITE_ID = `${practice.baseUrl}/#website`;

export function buildWebSite() {
  return {
    "@type": "WebSite",
    "@id": WEBSITE_ID,
    url: practice.baseUrl,
    name: practice.alternateName,
    description: practice.description,
    inLanguage: "de-DE",
    publisher: { "@id": organizationId },
  };
}
